import React from 'react'
import { Message } from '../Message'
import { AnimatedText } from '../Message/AnimatedText'
import { Inline } from '~/styles'

type SelectedQuestionMessageProps = {
  selectedQuestion?: string
}

export const SelectedQuestionMessage = ({ selectedQuestion }: SelectedQuestionMessageProps): JSX.Element => {
  const noQuestionsWereSelected = !selectedQuestion

  if (noQuestionsWereSelected) return <></>

  return (
    <Message.RootRight>
      <Inline>
        <Message.FromRight>
          <AnimatedText>{selectedQuestion}</AnimatedText>
        </Message.FromRight>
      </Inline>
    </Message.RootRight>
  )
}
